module.exports = __webpack_public_path__ + "images/banner-guangxi.jpg?aec18669436ec603d4bb566b81b886f4";


//////////////////
// WEBPACK FOOTER
// ./src/images/active/banner-guangxi.jpg
// module id = 172
// module chunks = 1